import { push } from 'connected-react-router';
import { getLastLocation } from '@webapp/utils/release/last-location';

export const openRelease = (
  artistId: string,
  releaseId: string,
  section?: string
) => {
  let path = getLastLocation(artistId, releaseId);

  if (section) {
    path = `/release/${artistId}/${releaseId}/${section}`;
  }

  return push(path);
};
